import React from 'react';
import { Link } from 'react-router-dom';
import { usePromoConfig } from '../hooks/usePromoConfig';
import { Trophy } from 'lucide-react';

export function Footer() {
  const { promoConfig } = usePromoConfig();
  const hasActiveCompetition = promoConfig?.is_active && promoConfig?.competition_terms_content;

  return (
    <footer className="bg-gray-800 text-gray-300 py-8 mt-auto border-t border-gray-700">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-sm">© {new Date().getFullYear()} Wayja. All rights reserved.</p>
          </div>
          <nav>
            <ul className="flex flex-wrap justify-center gap-4 md:gap-6">
              <li>
                <Link 
                  to="/about" 
                  className="text-sm hover:text-wayja-teal transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms" 
                  className="text-sm hover:text-wayja-teal transition-colors"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link 
                  to="/market-standards" 
                  className="text-sm hover:text-wayja-teal transition-colors"
                >
                  Market Standards
                </Link>
              </li>
              {hasActiveCompetition && (
                <li>
                  <Link 
                    to="/competition-terms" 
                    className="text-sm hover:text-purple-400 transition-colors flex items-center gap-1"
                  >
                    <Trophy className="w-3.5 h-3.5" />
                    Competition T&Cs
                  </Link>
                </li>
              )}
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
} 